import { useEffect, useRef } from 'react';

type UseClickEnter = (onClick: () => void, active?: boolean) => void;

const useClickEnter: UseClickEnter = (onClick, active = true) => {
	const onClickRef = useRef(onClick);

	useEffect(() => {
		onClickRef.current = onClick;
	}, [onClick]);

	useEffect(() => {
		if (!active) return;

		const handleKeyDown = (e: KeyboardEvent) => {
			if (e.key !== 'Enter') return;
			if (document.activeElement) {
				(document.activeElement as HTMLElement).blur();
			}
			onClickRef.current();
		};

		document.addEventListener('keydown', handleKeyDown, false);
		return () => {
			document.removeEventListener('keydown', handleKeyDown, false);
		};
	}, [active]);
};

export default useClickEnter;
